import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { editAppTitle } from "../helpers/helper";
import { useSelector } from "react-redux";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";

function Aside({ openAside, setOpenAside }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { organization } = useSelector((state) => state.organization);

  const matchesPath = (value) => {
    if (value === "/") return location.pathname === "/";
    return (
      location.pathname === value ||
      location.pathname.startsWith(value + "/")
    );
  };

  const renderListClasses = (path) => {
    if (Array.isArray(path)) {
      return path.some(matchesPath) ? "active-aside-items-list" : "";
    }

    return matchesPath(path) ? "active-aside-items-list" : "";
  };

  const navigateTo = (path, title) => {
    navigate(path);
    setOpenAside(false);
    editAppTitle(title);
  };

  const auctionSubnav = [
    { key: "", label: "Overview" },
    { key: "new", label: "Auction Creation" },
    { key: "history", label: "Auctions History" },
    { key: "live", label: "Live Room" },
  ];

  const auctionTab = useMemo(() => {
    if (!matchesPath("/auctions")) return "";

  
  }, [location.pathname, location.search]);

  const isAuctionsActive = matchesPath("/auctions");

  const navigateToAuctionTab = (tab, event) => {
    if (event) event.stopPropagation();
    navigate(`/auctions/${tab}`);
    setOpenAside(false);
    editAppTitle("Auctions");
  };

  return (
    <aside className={openAside ? "aside-list-open black" : "aside-list black"}>
      <ul className={openAside ? "aside-items-list-open" : "aside-items-list"}>
        <li
          className={renderListClasses("/")}
          onClick={() => navigateTo("/", "Dashboard")}
          data-tooltip-id="dashboard-tooltip"
          data-tooltip-content="Dashboard"
          data-tooltip-place="right"
        >
          <span className="material-symbols-outlined icon target-dashboard">
            dashboard
          </span>
          {!openAside ? <Tooltip id="dashboard-tooltip" /> : null}
          {openAside && <p className="semi-bold">Dashboard</p>}
        </li>

        <li
          className={renderListClasses("/pickups")}
          onClick={() => navigateTo("/pickups", "Pickups")}
          data-tooltip-id="pickup-tooltip"
          data-tooltip-content="Pickup Request"
          data-tooltip-place="right"
        >
          <span className="material-symbols-outlined icon target-pickups">
            local_shipping
          </span>
          {!openAside ? <Tooltip id="pickup-tooltip" /> : null}
          {openAside && <p className="semi-bold">Pickup Request</p>}
        </li>

        {organization?.type === "recycler" && (
          <li
            className={renderListClasses(["/inventory", "/create-lot"])}
            onClick={() => navigateTo("/inventory", "Inventory")}
            data-tooltip-id="inventory-tooltip"
            data-tooltip-content="Inventory"
            data-tooltip-place="right"
          >
            <span className="material-symbols-outlined icon">inventory</span>
            {!openAside ? <Tooltip id="inventory-tooltip" /> : null}
            {openAside && <p className="semi-bold">Inventory</p>}
          </li>
        )}

        <li
          className={renderListClasses("/network")}
          onClick={() => navigateTo("/network", "My Network")}
          data-tooltip-id="network-tooltip"
          data-tooltip-content="My Network"
          data-tooltip-place="right"
        >
          <span className="material-symbols-outlined icon">diversity_3</span>
          {!openAside ? <Tooltip id="network-tooltip" /> : null}
          {openAside && <p className="semi-bold">My Network</p>}
        </li>
        {(organization?.type === "industry" || organization?.type === "recycler") && (
          <>
            <li className={`${renderListClasses("/auctions")} aside-item-auctions`}>
              <div
                className="aside-item-main"
                onClick={() => navigateTo("/auctions?tab=overview", "Auctions")}
              >
                <span className="material-symbols-outlined icon">gavel</span>
                {openAside && <p className="semi-bold">Auctions</p>}
              </div>



               {!openAside && (
                <div className="aside-submenu aside-submenu-flyout">
                  <p className="aside-submenu-title">AUCTIONS MENU</p>
                  {auctionSubnav.map((item) => (
                    <button
                      key={item.key}
                      type="button"
                      className={`aside-submenu-item ${auctionTab === item.key ? "active" : ""
                        }`}
                      onClick={(event) => navigateToAuctionTab(item.key, event)}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              )} 


            </li>

             {openAside && isAuctionsActive && (
              <li className="aside-submenu-inline">
                <div className="aside-submenu">
                  <p className="aside-submenu-title">AUCTIONS MENU</p>
                  {auctionSubnav.map((item) => (
                    <button
                      key={item.key}
                      type="button"
                      className={`aside-submenu-item ${auctionTab === item.key ? "active" : ""
                        }`}
                      onClick={(event) => navigateToAuctionTab(item.key, event)}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              </li>
            )} 



          </>
        )} 

        <li
          className={renderListClasses("/organization")}
          onClick={() => navigateTo("/organization", "Management")}
          data-tooltip-id="organization-tooltip"
          data-tooltip-content="Management"
          data-tooltip-place="right"
        >
          <span className="material-symbols-outlined icon">groups</span>
          {!openAside ? <Tooltip id="organization-tooltip" /> : null}
          {openAside && <p className="semi-bold">Management</p>}
        </li>

        <li
          className={renderListClasses("/plans-billings")}
          onClick={() => navigateTo("/plans-billings", "Plans")}
          data-tooltip-id="plans-tooltip"
          data-tooltip-content="Plans & Billings"
          data-tooltip-place="right"
        >
          <span className="material-symbols-outlined icon">receipt_long</span>
          {!openAside ? <Tooltip id="plans-tooltip" /> : null}
          {openAside && <p className="semi-bold">Plans & Billings</p>}
        </li>

        <li
          className={location.pathname === "/review-insights" ? "active-aside-items-list" : ""}
          onClick={() => {
            navigate("/review-insights");
            setOpenAside(false);
            editAppTitle("Insights");
          }}
          data-tooltip-id="insights-tooltip"
          data-tooltip-content="Review Insights"
          data-tooltip-place="right"
        >
          <span className="material-symbols-outlined icon">reviews</span>
          {!openAside ? <Tooltip id="insights-tooltip" /> : null}
          {openAside && <p className="semi-bold">Review Insights</p>}
        </li>

        <li
          className={location.pathname === "/reports" ? "active-aside-items-list" : ""}
          onClick={() => {
            navigate("/reports");
            setOpenAside(false);
            editAppTitle("Reports");
          }}
          data-tooltip-id="reports-tooltip"
          data-tooltip-content="Analytics"
          data-tooltip-place="right"
        >
          <span className="material-symbols-outlined target-reports icon">
            troubleshoot
          </span>
          {!openAside ? <Tooltip id="reports-tooltip" /> : null}
          {openAside && <p className="semi-bold">Analytics</p>}
        </li>

        <li
          className={location.pathname === "/setting" ? "active-aside-items-list" : ""}
          onClick={() => {
            navigate("/setting");
            setOpenAside(false);
            editAppTitle("Settings");
          }}
          data-tooltip-id="setting-tooltip"
          data-tooltip-content="Settings"
          data-tooltip-place="right"
        >
          <span className="material-symbols-outlined icon">settings</span>
          {!openAside ? <Tooltip id="setting-tooltip" /> : null}
          {openAside && <p className="semi-bold">Settings</p>}
        </li>
      </ul>

      <div>
        {openAside ? (
          <div className="flex align-center">
            <img
              style={{ width: 30, height: 30 }}
              className="circle"
              src="/images/wasteknot_logo.png"
              alt="logo"
            />
          </div>
        ) : (
          <img src="/images/wasteknot_logo.png" alt="logo" />
        )}
      </div>
    </aside>
  );
}

export default Aside;


